import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

export const firebaseConfig = {
  apiKey: "AIzaSyCiIl59GGby3MLr3ctQTjKFxVsZpS7Ka9k",
  authDomain: "cs-cams.firebaseapp.com",
  databaseURL: "https://cs-cams.firebaseio.com",
  projectId: "cs-cams",
  storageBucket: "cs-cams.appspot.com",
  messagingSenderId: "161606674950",
  appId: "1:161606674950:web:12648b87bc1815e46fb187",
  measurementId: "G-124PCKX7JZ",
};

const firebaseApp = initializeApp(firebaseConfig);
export const firebaseDb = getDatabase(firebaseApp);
